/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Waypoint } from "../../waypoints";

export const protobufPackage = "skills";

/**
 * Note: customer portal doesn't seem to like imports from google. Otherwise could just use:
 * import "google/protobuf/timestamp.proto";
 */
export interface Timestamp {
  /**
   * Represents seconds of UTC time since Unix epoch
   * 1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
   * 9999-12-31T23:59:59Z inclusive.
   */
  seconds: number;
  /**
   * Non-negative fractions of a second at nanosecond resolution. Negative
   * second values with fractions must still have non-negative nanos values
   * that count forward in time. Must be from 0 to 999,999,999
   * inclusive.
   */
  nanos: number;
}

export interface TimestampedWaypoint {
  timestamp: Timestamp | undefined;
  waypoint: Waypoint | undefined;
}

export interface DancingDroneActionArgs {
  timestampedWaypoints: TimestampedWaypoint[];
}

export interface DancingDroneSplineActionArgs {
  timestampedWaypoints: TimestampedWaypoint[];
  splineConstructionArgs: DancingDroneSplineActionArgs_SplineConstructionArgs | undefined;
}

export interface DancingDroneSplineActionArgs_SplineConstructionArgs {
  /** Max speed [m/s]/ */
  maxSpeed?:
    | number
    | undefined;
  /** Max acceleration [m/s^2] */
  maxAccelMag?:
    | number
    | undefined;
  /** Whether to use trapezoidal builder */
  useTrapezoidalBuilder?: boolean | undefined;
}

export interface DancingDroneResultData {
}

export interface DancingDroneSplineResultData {
}

export interface DancingDroneActionStateData {
  currentWaypointIdx: number;
  timeDeltaForCurrentWaypoint: number;
  distanceToCurrentWaypoint: number;
}

export interface DancingDroneSplineActionStateData {
}

export interface WaitForPreciseFaultRequest {
  utime: number;
  targetTimestamp: Timestamp | undefined;
  whichFault: WaitForPreciseFaultRequest_WhichFault;
}

/** Make a new enum to avoid pulling all of faults into mission dependencies */
export enum WaitForPreciseFaultRequest_WhichFault {
  WAIT_FOR_PRECISE_PREP = 0,
  WAIT_FOR_PRECISE_LAUNCH = 1,
  UNRECOGNIZED = -1,
}

export function waitForPreciseFaultRequest_WhichFaultFromJSON(object: any): WaitForPreciseFaultRequest_WhichFault {
  switch (object) {
    case 0:
    case "WAIT_FOR_PRECISE_PREP":
      return WaitForPreciseFaultRequest_WhichFault.WAIT_FOR_PRECISE_PREP;
    case 1:
    case "WAIT_FOR_PRECISE_LAUNCH":
      return WaitForPreciseFaultRequest_WhichFault.WAIT_FOR_PRECISE_LAUNCH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WaitForPreciseFaultRequest_WhichFault.UNRECOGNIZED;
  }
}

export function waitForPreciseFaultRequest_WhichFaultToJSON(object: WaitForPreciseFaultRequest_WhichFault): string {
  switch (object) {
    case WaitForPreciseFaultRequest_WhichFault.WAIT_FOR_PRECISE_PREP:
      return "WAIT_FOR_PRECISE_PREP";
    case WaitForPreciseFaultRequest_WhichFault.WAIT_FOR_PRECISE_LAUNCH:
      return "WAIT_FOR_PRECISE_LAUNCH";
    case WaitForPreciseFaultRequest_WhichFault.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface WaitForPreciseFaultActionArgs {
  request: WaitForPreciseFaultRequest | undefined;
}

export interface WaitForPreciseFaultResultData {
}

export interface WaitForPreciseFaultActionStateData {
}

function createBaseTimestamp(): Timestamp {
  return { seconds: 0, nanos: 0 };
}

export const Timestamp = {
  encode(message: Timestamp, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.seconds !== 0) {
      writer.uint32(8).int64(message.seconds);
    }
    if (message.nanos !== 0) {
      writer.uint32(16).int32(message.nanos);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Timestamp {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimestamp();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.seconds = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.nanos = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Timestamp {
    return {
      seconds: isSet(object.seconds) ? globalThis.Number(object.seconds) : 0,
      nanos: isSet(object.nanos) ? globalThis.Number(object.nanos) : 0,
    };
  },

  toJSON(message: Timestamp): unknown {
    const obj: any = {};
    if (message.seconds !== 0) {
      obj.seconds = Math.round(message.seconds);
    }
    if (message.nanos !== 0) {
      obj.nanos = Math.round(message.nanos);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Timestamp>, I>>(base?: I): Timestamp {
    return Timestamp.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Timestamp>, I>>(object: I): Timestamp {
    const message = createBaseTimestamp();
    message.seconds = object.seconds ?? 0;
    message.nanos = object.nanos ?? 0;
    return message;
  },
};

function createBaseTimestampedWaypoint(): TimestampedWaypoint {
  return { timestamp: undefined, waypoint: undefined };
}

export const TimestampedWaypoint = {
  encode(message: TimestampedWaypoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timestamp !== undefined) {
      Timestamp.encode(message.timestamp, writer.uint32(10).fork()).ldelim();
    }
    if (message.waypoint !== undefined) {
      Waypoint.encode(message.waypoint, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TimestampedWaypoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTimestampedWaypoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.timestamp = Timestamp.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.waypoint = Waypoint.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TimestampedWaypoint {
    return {
      timestamp: isSet(object.timestamp) ? Timestamp.fromJSON(object.timestamp) : undefined,
      waypoint: isSet(object.waypoint) ? Waypoint.fromJSON(object.waypoint) : undefined,
    };
  },

  toJSON(message: TimestampedWaypoint): unknown {
    const obj: any = {};
    if (message.timestamp !== undefined) {
      obj.timestamp = Timestamp.toJSON(message.timestamp);
    }
    if (message.waypoint !== undefined) {
      obj.waypoint = Waypoint.toJSON(message.waypoint);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TimestampedWaypoint>, I>>(base?: I): TimestampedWaypoint {
    return TimestampedWaypoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TimestampedWaypoint>, I>>(object: I): TimestampedWaypoint {
    const message = createBaseTimestampedWaypoint();
    message.timestamp = (object.timestamp !== undefined && object.timestamp !== null)
      ? Timestamp.fromPartial(object.timestamp)
      : undefined;
    message.waypoint = (object.waypoint !== undefined && object.waypoint !== null)
      ? Waypoint.fromPartial(object.waypoint)
      : undefined;
    return message;
  },
};

function createBaseDancingDroneActionArgs(): DancingDroneActionArgs {
  return { timestampedWaypoints: [] };
}

export const DancingDroneActionArgs = {
  encode(message: DancingDroneActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.timestampedWaypoints) {
      TimestampedWaypoint.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DancingDroneActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDancingDroneActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.timestampedWaypoints.push(TimestampedWaypoint.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DancingDroneActionArgs {
    return {
      timestampedWaypoints: globalThis.Array.isArray(object?.timestampedWaypoints)
        ? object.timestampedWaypoints.map((e: any) => TimestampedWaypoint.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DancingDroneActionArgs): unknown {
    const obj: any = {};
    if (message.timestampedWaypoints?.length) {
      obj.timestampedWaypoints = message.timestampedWaypoints.map((e) => TimestampedWaypoint.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DancingDroneActionArgs>, I>>(base?: I): DancingDroneActionArgs {
    return DancingDroneActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DancingDroneActionArgs>, I>>(object: I): DancingDroneActionArgs {
    const message = createBaseDancingDroneActionArgs();
    message.timestampedWaypoints = object.timestampedWaypoints?.map((e) => TimestampedWaypoint.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDancingDroneSplineActionArgs(): DancingDroneSplineActionArgs {
  return { timestampedWaypoints: [], splineConstructionArgs: undefined };
}

export const DancingDroneSplineActionArgs = {
  encode(message: DancingDroneSplineActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.timestampedWaypoints) {
      TimestampedWaypoint.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.splineConstructionArgs !== undefined) {
      DancingDroneSplineActionArgs_SplineConstructionArgs.encode(
        message.splineConstructionArgs,
        writer.uint32(18).fork(),
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DancingDroneSplineActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDancingDroneSplineActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.timestampedWaypoints.push(TimestampedWaypoint.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.splineConstructionArgs = DancingDroneSplineActionArgs_SplineConstructionArgs.decode(
            reader,
            reader.uint32(),
          );
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DancingDroneSplineActionArgs {
    return {
      timestampedWaypoints: globalThis.Array.isArray(object?.timestampedWaypoints)
        ? object.timestampedWaypoints.map((e: any) => TimestampedWaypoint.fromJSON(e))
        : [],
      splineConstructionArgs: isSet(object.splineConstructionArgs)
        ? DancingDroneSplineActionArgs_SplineConstructionArgs.fromJSON(object.splineConstructionArgs)
        : undefined,
    };
  },

  toJSON(message: DancingDroneSplineActionArgs): unknown {
    const obj: any = {};
    if (message.timestampedWaypoints?.length) {
      obj.timestampedWaypoints = message.timestampedWaypoints.map((e) => TimestampedWaypoint.toJSON(e));
    }
    if (message.splineConstructionArgs !== undefined) {
      obj.splineConstructionArgs = DancingDroneSplineActionArgs_SplineConstructionArgs.toJSON(
        message.splineConstructionArgs,
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DancingDroneSplineActionArgs>, I>>(base?: I): DancingDroneSplineActionArgs {
    return DancingDroneSplineActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DancingDroneSplineActionArgs>, I>>(object: I): DancingDroneSplineActionArgs {
    const message = createBaseDancingDroneSplineActionArgs();
    message.timestampedWaypoints = object.timestampedWaypoints?.map((e) => TimestampedWaypoint.fromPartial(e)) || [];
    message.splineConstructionArgs =
      (object.splineConstructionArgs !== undefined && object.splineConstructionArgs !== null)
        ? DancingDroneSplineActionArgs_SplineConstructionArgs.fromPartial(object.splineConstructionArgs)
        : undefined;
    return message;
  },
};

function createBaseDancingDroneSplineActionArgs_SplineConstructionArgs(): DancingDroneSplineActionArgs_SplineConstructionArgs {
  return { maxSpeed: undefined, maxAccelMag: undefined, useTrapezoidalBuilder: undefined };
}

export const DancingDroneSplineActionArgs_SplineConstructionArgs = {
  encode(
    message: DancingDroneSplineActionArgs_SplineConstructionArgs,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.maxSpeed !== undefined) {
      writer.uint32(13).float(message.maxSpeed);
    }
    if (message.maxAccelMag !== undefined) {
      writer.uint32(21).float(message.maxAccelMag);
    }
    if (message.useTrapezoidalBuilder !== undefined) {
      writer.uint32(24).bool(message.useTrapezoidalBuilder);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DancingDroneSplineActionArgs_SplineConstructionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDancingDroneSplineActionArgs_SplineConstructionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.maxSpeed = reader.float();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.maxAccelMag = reader.float();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.useTrapezoidalBuilder = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DancingDroneSplineActionArgs_SplineConstructionArgs {
    return {
      maxSpeed: isSet(object.maxSpeed) ? globalThis.Number(object.maxSpeed) : undefined,
      maxAccelMag: isSet(object.maxAccelMag) ? globalThis.Number(object.maxAccelMag) : undefined,
      useTrapezoidalBuilder: isSet(object.useTrapezoidalBuilder)
        ? globalThis.Boolean(object.useTrapezoidalBuilder)
        : undefined,
    };
  },

  toJSON(message: DancingDroneSplineActionArgs_SplineConstructionArgs): unknown {
    const obj: any = {};
    if (message.maxSpeed !== undefined) {
      obj.maxSpeed = message.maxSpeed;
    }
    if (message.maxAccelMag !== undefined) {
      obj.maxAccelMag = message.maxAccelMag;
    }
    if (message.useTrapezoidalBuilder !== undefined) {
      obj.useTrapezoidalBuilder = message.useTrapezoidalBuilder;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DancingDroneSplineActionArgs_SplineConstructionArgs>, I>>(
    base?: I,
  ): DancingDroneSplineActionArgs_SplineConstructionArgs {
    return DancingDroneSplineActionArgs_SplineConstructionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DancingDroneSplineActionArgs_SplineConstructionArgs>, I>>(
    object: I,
  ): DancingDroneSplineActionArgs_SplineConstructionArgs {
    const message = createBaseDancingDroneSplineActionArgs_SplineConstructionArgs();
    message.maxSpeed = object.maxSpeed ?? undefined;
    message.maxAccelMag = object.maxAccelMag ?? undefined;
    message.useTrapezoidalBuilder = object.useTrapezoidalBuilder ?? undefined;
    return message;
  },
};

function createBaseDancingDroneResultData(): DancingDroneResultData {
  return {};
}

export const DancingDroneResultData = {
  encode(_: DancingDroneResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DancingDroneResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDancingDroneResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DancingDroneResultData {
    return {};
  },

  toJSON(_: DancingDroneResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DancingDroneResultData>, I>>(base?: I): DancingDroneResultData {
    return DancingDroneResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DancingDroneResultData>, I>>(_: I): DancingDroneResultData {
    const message = createBaseDancingDroneResultData();
    return message;
  },
};

function createBaseDancingDroneSplineResultData(): DancingDroneSplineResultData {
  return {};
}

export const DancingDroneSplineResultData = {
  encode(_: DancingDroneSplineResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DancingDroneSplineResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDancingDroneSplineResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DancingDroneSplineResultData {
    return {};
  },

  toJSON(_: DancingDroneSplineResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DancingDroneSplineResultData>, I>>(base?: I): DancingDroneSplineResultData {
    return DancingDroneSplineResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DancingDroneSplineResultData>, I>>(_: I): DancingDroneSplineResultData {
    const message = createBaseDancingDroneSplineResultData();
    return message;
  },
};

function createBaseDancingDroneActionStateData(): DancingDroneActionStateData {
  return { currentWaypointIdx: 0, timeDeltaForCurrentWaypoint: 0, distanceToCurrentWaypoint: 0 };
}

export const DancingDroneActionStateData = {
  encode(message: DancingDroneActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.currentWaypointIdx !== 0) {
      writer.uint32(8).int32(message.currentWaypointIdx);
    }
    if (message.timeDeltaForCurrentWaypoint !== 0) {
      writer.uint32(21).float(message.timeDeltaForCurrentWaypoint);
    }
    if (message.distanceToCurrentWaypoint !== 0) {
      writer.uint32(29).float(message.distanceToCurrentWaypoint);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DancingDroneActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDancingDroneActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.currentWaypointIdx = reader.int32();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.timeDeltaForCurrentWaypoint = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.distanceToCurrentWaypoint = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DancingDroneActionStateData {
    return {
      currentWaypointIdx: isSet(object.currentWaypointIdx) ? globalThis.Number(object.currentWaypointIdx) : 0,
      timeDeltaForCurrentWaypoint: isSet(object.timeDeltaForCurrentWaypoint)
        ? globalThis.Number(object.timeDeltaForCurrentWaypoint)
        : 0,
      distanceToCurrentWaypoint: isSet(object.distanceToCurrentWaypoint)
        ? globalThis.Number(object.distanceToCurrentWaypoint)
        : 0,
    };
  },

  toJSON(message: DancingDroneActionStateData): unknown {
    const obj: any = {};
    if (message.currentWaypointIdx !== 0) {
      obj.currentWaypointIdx = Math.round(message.currentWaypointIdx);
    }
    if (message.timeDeltaForCurrentWaypoint !== 0) {
      obj.timeDeltaForCurrentWaypoint = message.timeDeltaForCurrentWaypoint;
    }
    if (message.distanceToCurrentWaypoint !== 0) {
      obj.distanceToCurrentWaypoint = message.distanceToCurrentWaypoint;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DancingDroneActionStateData>, I>>(base?: I): DancingDroneActionStateData {
    return DancingDroneActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DancingDroneActionStateData>, I>>(object: I): DancingDroneActionStateData {
    const message = createBaseDancingDroneActionStateData();
    message.currentWaypointIdx = object.currentWaypointIdx ?? 0;
    message.timeDeltaForCurrentWaypoint = object.timeDeltaForCurrentWaypoint ?? 0;
    message.distanceToCurrentWaypoint = object.distanceToCurrentWaypoint ?? 0;
    return message;
  },
};

function createBaseDancingDroneSplineActionStateData(): DancingDroneSplineActionStateData {
  return {};
}

export const DancingDroneSplineActionStateData = {
  encode(_: DancingDroneSplineActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DancingDroneSplineActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDancingDroneSplineActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DancingDroneSplineActionStateData {
    return {};
  },

  toJSON(_: DancingDroneSplineActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DancingDroneSplineActionStateData>, I>>(
    base?: I,
  ): DancingDroneSplineActionStateData {
    return DancingDroneSplineActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DancingDroneSplineActionStateData>, I>>(
    _: I,
  ): DancingDroneSplineActionStateData {
    const message = createBaseDancingDroneSplineActionStateData();
    return message;
  },
};

function createBaseWaitForPreciseFaultRequest(): WaitForPreciseFaultRequest {
  return { utime: 0, targetTimestamp: undefined, whichFault: 0 };
}

export const WaitForPreciseFaultRequest = {
  encode(message: WaitForPreciseFaultRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.targetTimestamp !== undefined) {
      Timestamp.encode(message.targetTimestamp, writer.uint32(18).fork()).ldelim();
    }
    if (message.whichFault !== 0) {
      writer.uint32(24).int32(message.whichFault);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WaitForPreciseFaultRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaitForPreciseFaultRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.targetTimestamp = Timestamp.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.whichFault = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WaitForPreciseFaultRequest {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      targetTimestamp: isSet(object.targetTimestamp) ? Timestamp.fromJSON(object.targetTimestamp) : undefined,
      whichFault: isSet(object.whichFault) ? waitForPreciseFaultRequest_WhichFaultFromJSON(object.whichFault) : 0,
    };
  },

  toJSON(message: WaitForPreciseFaultRequest): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.targetTimestamp !== undefined) {
      obj.targetTimestamp = Timestamp.toJSON(message.targetTimestamp);
    }
    if (message.whichFault !== 0) {
      obj.whichFault = waitForPreciseFaultRequest_WhichFaultToJSON(message.whichFault);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WaitForPreciseFaultRequest>, I>>(base?: I): WaitForPreciseFaultRequest {
    return WaitForPreciseFaultRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WaitForPreciseFaultRequest>, I>>(object: I): WaitForPreciseFaultRequest {
    const message = createBaseWaitForPreciseFaultRequest();
    message.utime = object.utime ?? 0;
    message.targetTimestamp = (object.targetTimestamp !== undefined && object.targetTimestamp !== null)
      ? Timestamp.fromPartial(object.targetTimestamp)
      : undefined;
    message.whichFault = object.whichFault ?? 0;
    return message;
  },
};

function createBaseWaitForPreciseFaultActionArgs(): WaitForPreciseFaultActionArgs {
  return { request: undefined };
}

export const WaitForPreciseFaultActionArgs = {
  encode(message: WaitForPreciseFaultActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.request !== undefined) {
      WaitForPreciseFaultRequest.encode(message.request, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WaitForPreciseFaultActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaitForPreciseFaultActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.request = WaitForPreciseFaultRequest.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WaitForPreciseFaultActionArgs {
    return { request: isSet(object.request) ? WaitForPreciseFaultRequest.fromJSON(object.request) : undefined };
  },

  toJSON(message: WaitForPreciseFaultActionArgs): unknown {
    const obj: any = {};
    if (message.request !== undefined) {
      obj.request = WaitForPreciseFaultRequest.toJSON(message.request);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WaitForPreciseFaultActionArgs>, I>>(base?: I): WaitForPreciseFaultActionArgs {
    return WaitForPreciseFaultActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WaitForPreciseFaultActionArgs>, I>>(
    object: I,
  ): WaitForPreciseFaultActionArgs {
    const message = createBaseWaitForPreciseFaultActionArgs();
    message.request = (object.request !== undefined && object.request !== null)
      ? WaitForPreciseFaultRequest.fromPartial(object.request)
      : undefined;
    return message;
  },
};

function createBaseWaitForPreciseFaultResultData(): WaitForPreciseFaultResultData {
  return {};
}

export const WaitForPreciseFaultResultData = {
  encode(_: WaitForPreciseFaultResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WaitForPreciseFaultResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaitForPreciseFaultResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): WaitForPreciseFaultResultData {
    return {};
  },

  toJSON(_: WaitForPreciseFaultResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<WaitForPreciseFaultResultData>, I>>(base?: I): WaitForPreciseFaultResultData {
    return WaitForPreciseFaultResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WaitForPreciseFaultResultData>, I>>(_: I): WaitForPreciseFaultResultData {
    const message = createBaseWaitForPreciseFaultResultData();
    return message;
  },
};

function createBaseWaitForPreciseFaultActionStateData(): WaitForPreciseFaultActionStateData {
  return {};
}

export const WaitForPreciseFaultActionStateData = {
  encode(_: WaitForPreciseFaultActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WaitForPreciseFaultActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaitForPreciseFaultActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): WaitForPreciseFaultActionStateData {
    return {};
  },

  toJSON(_: WaitForPreciseFaultActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<WaitForPreciseFaultActionStateData>, I>>(
    base?: I,
  ): WaitForPreciseFaultActionStateData {
    return WaitForPreciseFaultActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WaitForPreciseFaultActionStateData>, I>>(
    _: I,
  ): WaitForPreciseFaultActionStateData {
    const message = createBaseWaitForPreciseFaultActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
